var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgThietBi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 28.5714C0.333496 12.7919 13.1254 0 28.9049 0H71.7621C87.5416 0 100.333 12.7919 100.333 28.5714V71.4286C100.333 87.2081 87.5416 100 71.7621 100H28.9049C13.1254 100 0.333496 87.2081 0.333496 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_855)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9764 63.2583H34.8246C25.7979 63.2583 23.5479 61.0083 23.5479 51.9815V35.9101C23.5479 26.8833 25.7979 24.6333 34.8246 24.6333H63.03C72.0568 24.6333 74.3068 26.8833 74.3068 35.9101",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9766 75.3667V63.2595",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5479 52.5452H44.9764",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2446 75.3667H44.9768",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1175 52.1424V67.4371C77.1175 73.7853 75.5372 75.3656 69.189 75.3656H59.68C53.3318 75.3656 51.7515 73.7853 51.7515 67.4371V52.1424C51.7515 45.7942 53.3318 44.2139 59.68 44.2139H69.189C75.5372 44.2139 77.1175 45.7942 77.1175 52.1424Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3817 66.7411H64.4058",
    stroke: "white",
    strokeWidth: 5.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_855",
    x1: 50.3335,
    y1: 0,
    x2: 50.3335,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9F1D"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThietBi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ThietBi.c9e119e0.svg";
export { ForwardRef as ReactComponent };